import React, { useState } from 'react';
import { API_BASE_URL } from '../config/api';

const initials = (name = '') =>
  name.split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0].toUpperCase()).join('') || 'S';
const photoSrc = (p) => (!p ? null : /^(https?:|data:)/.test(p) ? p : `${API_BASE_URL}${p}`);

// Digital student ID card shown at the top of the landing (Today) view.
function StudentIdCard({ user, userProfile, idCard, pct, isImpersonated }) {
  const [photoFailed, setPhotoFailed] = useState(false);
  const p = userProfile || {};
  const section = p.section || user.section;
  const roll = p.rollNo || p.rollNumber;
  const adm = idCard?.scholarNo || p.scholarNo || p.studentId;
  const src = photoFailed ? null : photoSrc(p.profilePicture);
  const meta = adm ? `Scholar / Admission ID: ${adm}` : '';
  const classLine = [`Class ${user.class}${section ? ` - Section ${section}` : ''}`, roll ? `Roll No. ${roll}` : ''].filter(Boolean).join(' • ');

  return (
    <header className="sh-idcard">
      <div className="sh-avatar">
        {src ? <img src={src} alt="" onError={() => setPhotoFailed(true)} /> : <span>{initials(user.name)}</span>}
      </div>
      <div className="sh-id-info">
        <div className="sh-id-name">{user.name}</div>
        <div className="sh-id-pills">
          <span className="sh-pill">{classLine}</span>
          {isImpersonated && <span className="sh-pill">Viewing as staff</span>}
        </div>
        {meta && <div className="sh-id-meta">{meta}</div>}
      </div>
      {pct !== null && <span className={`sh-att-pill ${pct < 75 ? 'sh-att-low' : ''}`}>Attendance: {pct}%</span>}
    </header>
  );
}

export default StudentIdCard;
